import { createServerFn } from "@tanstack/react-start";

/** Är auktioner påslagna? Styrs av en strömbrytare i admin, avstängd som standard. */
export const getAuctionsEnabled = createServerFn({ method: "GET" }).handler(async () => {
  const { readSettings } = await import("./orders.server");
  const settings = await readSettings();
  return { enabled: settings.auctionsEnabled };
});
